
import React, { useState, useEffect, useMemo } from 'react';
import { 
  User, 
  MapPin, 
  Calendar, 
  BookOpen, 
  Target, 
  TrendingUp, 
  Award,
  Globe,
  CheckCircle2,
  Circle,
  Play,
  Video,
  Clock,
  Download,
  FileText,
  Languages,
  ChevronLeft,
  ChevronRight,
  UserX,
  X,
  ClipboardList,
  Trash2,
  CalendarDays,
  Filter,
  ArrowUp, 
  ArrowDown, 
  ArrowUpDown,
  SquareChartGantt,
  LandPlot,
  Edit,
  Save,
  Table,
  CheckCircle,
  ChartNoAxesColumnIncreasing,
  Upload,
  CirclePlus,
  EyeIcon
} from 'lucide-react';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import html2canvas from 'html2canvas';
import { renderToStaticMarkup } from 'react-dom/server';
import { createRoot } from 'react-dom/client';

import SmartGoalModal from './SmartGoalModal';


const SmartGoals = () => {

  const WP_REST_BASE = "https://higherstandardsacademy.com/wp-json/v1/hsasys-data"; 

  const [isOpen, setIsOpen] = useState(true);
  const [isVisible, setIsVisible] = useState(false);  
  const [isParticipant, setIsParticipant] = useState(false);  
  const [currentTeam, setCurrentTeam] = useState(null);
  const [currentTeamColor, setCurrentTeamColor] = useState(null);
  const [locations, setLocations] = useState([]);
  const [teams, setTeams] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [attendances, setAttendances] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [participantsByLocation, setParticipantsByLocation] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState("");
  const [selectedParticipantId, setSelectedParticipantId] = useState("");  
  const [userData, setUserData] = useState(null);  
  const [locationAttendanceData, setLocationAttendanceData] = useState([]);
  const [locationsStatsData, setLocationsStatsData] = useState([]);  
  const [attendanceStatusData, setAttendanceStatusData] = useState([]);
  const [loading, setLoading] = useState(true);  
  const [error, setError] = useState(null);
  const [primaryColor, setPrimaryColor] = useState('#06415b');
  const [accentColor, setAccentColor] = useState('#c44c46');

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [attStatusStartDate, setAttStatusStartDate] = useState("");
  const [attStatusEndDate, setAttStatusEndDate] = useState("");

  const [fullnameFilter, setFullnameFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);

  const [attStatusCurrentPage, setAttStatusCurrentPage] = useState(1);

  const [selectedParticipant, setSelectedParticipant] = useState('');

  const [selectedParticipantName, setSelectedParticipantName] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');
 
  
  //Goals
  const GOALS_PER_PAGE = 20;
  const [locationGoalData, setlocationGoalData] = useState([]);
  const [selectedGoal, setSelectedGoal] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalEditOpen, setIsModalEditOpen] = useState(false);

const [editFormData, setEditFormData] = useState({
  minutes: '',
  participation: '',
  focus: '',
  excused: false,
  status: ''
});



  const handleSaveSmartGoal = (smartGoalData) => {
    console.log("Datos de la meta SMART recibidos", smartGoalData);
    
    // Aquí puedes hacer tu llamada a la API (ej: axios.post('/api/goals', smartGoalData))
    // O simplemente guardarlo en el estado de tu componente:
    //setGoalsList((prevGoals) => [...prevGoals, smartGoalData]);
    
    alert("¡Meta SMART registrada con éxito!");
  };


const handleEditClick = (record) => {  
  setSelectedRecord(record);
  setEditFormData({
    minutes: record.minutes,
    participation: record.participation,
    focus: record.focus,
    excused: record.excused,
    status: record.status
  });
  setIsModalEditOpen(true);
};

// Función para manejar cambios en el formulario
const handleInputChange = (e) => {
  const { name, value, type, checked } = e.target;
  setEditFormData(prev => ({
    ...prev,
    [name]: type === 'checkbox' ? checked : value
  }));
};

// Función para guardar los cambios
const handleSaveChanges = async () => {
  // Validar datos
  if (editFormData.participation < 0 || editFormData.participation > 100) {
    alert('Participation must be between 0 and 100');
    return;
  }
  
  if (editFormData.focus < 0 || editFormData.focus > 100) {
    alert('Focus must be between 0 and 100');
    return;
  }
  
  if (editFormData.minutes < 0) {
    alert('Minutes cannot be negative');
    return;
  }
  
  // Mostrar loading (opcional)
  setLoading(true);
  
  try {
    // Preparar datos para enviar
    const payload = {
      id: selectedRecord.id,
      minutes: editFormData.minutes,
      participation: editFormData.participation,
      focus: editFormData.focus,
      excused: editFormData.excused ? 1 : 0, // Convertir a número si es necesario
      status: editFormData.status
    };
    
    // Llamada a la API
    const url = `${WP_REST_BASE}/goals-update-record?id=${selectedRecord.id}`;
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
    
    if (!response.ok) {
      throw new Error('Failed to update record');
    }
    
    const updatedRecord = await response.json();

    await fetchLocationGoalData();

    setLocationAttendanceData(prevData =>
        prevData.map(record =>
          record.id === selectedRecord.id ? updatedRecord.data : record
        )
      );
  
    
    // Cerrar modal
    setIsModalEditOpen(false);
    setSelectedRecord(null);
    
    // Mostrar mensaje de éxito
    alert('Record updated successfully!');
    
  } catch (error) {
    console.error('Error updating record:', error);
    alert('Error updating record. Please try again.');
  } finally {
    setLoading(false);
  }
};










// const SMART_STEPS = [
//   { id: 'S', title: 'Específica (Specific)', label: '¿Qué quieres lograr exactamente?', placeholder: 'Ej. Incrementar las ventas del sitio web...' },
//   { id: 'M', title: 'Medible (Measurable)', label: '¿Cómo vas a medir el progreso?', placeholder: 'Ej. En un 15% mensual...' },
//   { id: 'A', title: 'Alcanzable (Achievable)', label: '¿Es realista? ¿Qué necesitas para lograrlo?', placeholder: 'Ej. Optimizando el SEO y campañas en Meta Ads...' },
//   { id: 'R', title: 'Relevante (Relevant)', label: '¿Por qué es importante para ti o tu negocio?', placeholder: 'Ej. Para mejorar la rentabilidad del negocio...' },
//   { id: 'T', title: 'Temporal (Time-bound)', label: '¿Cuál es la fecha límite?', placeholder: 'Ej. A más tardar el 31 de diciembre...' }
// ];


  function formatEpochDate(epoch) {  
    if (!epoch) return ""; 
    
    const date = new Date(Number(epoch) * 1000);

    const formatter = new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
    
    return formatter.format(date).replace(' ', '/');
  }


  const parseToMidnightTimestamp = (dateVal) => {
    if (!dateVal) return 0;
    const d = new Date(dateVal);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
  };

  const getDateOnly = (dateString) => {
    if (!dateString) return null;
    const parts = dateString.split('-');
    return `${parts[0]}-${parts[1]}-${parts[2]}`;
  };

  const getDateOnlyFromEpoch = (epoch) => {
    const date = new Date(epoch * 1000);
    return date.toISOString().split('T')[0];
  };

  const filteredGoals = useMemo(() => {
    return locationGoalData.filter(record => {
      let matchesParticipant = true;
      let matchesGroup = true;
      let matchesStatus = true;
      let matchesDate = true;

      if (selectedParticipant) {
        matchesParticipant = String(record.participant_id) === String(selectedParticipant);
      }
      
      if (selectedGroup) {
        matchesGroup = String(record.groupid) === String(selectedGroup);
      }
      
      if (statusFilter) {    
        matchesStatus = String(record.status) === String(statusFilter);    
      }
        
      // const recordDate = getDateOnlyFromEpoch(record.timecreated);
      // if (startDate && recordDate < startDate) return false;
      // if (endDate && recordDate > endDate) return false;
        
      return matchesParticipant && matchesGroup && matchesStatus;
    });
  }, [locationGoalData, selectedParticipant, selectedGroup, statusFilter, startDate, endDate]);


 const currentGoals = filteredGoals.slice(
    (currentPage - 1) * GOALS_PER_PAGE,
    currentPage * GOALS_PER_PAGE
  );


useEffect(() => {  
  setStartDate('');
  setEndDate('');
  setStatusFilter('');
  setSelectedGroup('');
  setCurrentPage(1); 

}, [selectedLocation]);



const uniqueGroups = useMemo(() => {
  
  const groupMap = new Map();
  
  locationGoalData.forEach(record => {
    if (!groupMap.has(record.groupid)) {
      groupMap.set(record.groupid, {
        id: record.groupid,
        name: record.groupname
      });
    }
  });
  
  return Array.from(groupMap.values())
    .sort((a, b) => a.name.localeCompare(b.name));
}, [locationGoalData]);


const uniqueParticipants = useMemo(() => {
  
  const nameMap = new Map();
  
  locationGoalData.forEach(record => {
    if (!nameMap.has(record.participant_id)) {
      nameMap.set(record.participant_id, {
        id: record.participant_id,
        name: record.fullname
      });
    }
  });
    
  return Array.from(nameMap.values())
    .sort((a, b) => a.name.localeCompare(b.name));
}, [locationGoalData]);


  const getStatusBadge = (status) => {

    if (status === -1) {
      status = 7;
    }
    const styles = {
      1: "bg-green-100 text-green-800 border-green-200",
      2: "bg-blue-100 text-blue-800 border-blue-200",
      4: "bg-blue-100 text-blue-800 border-blue-200",
      7: "bg-red-100 text-red-800 border-red-200"
    };

    const statusText = {
      1: "To Review",
      2: "Approved",
      3: "Completed",     
    };

    const text = statusText[status] || status;

    return (
      <span className={`px-2.5 py-1 text-[9px] font-semibold tracking-wider rounded-lg border ${styles[status] || "bg-gray-100"}`}>
        {text}
      </span>
    );
  };



const getStatusNameBadge = (status) => {

    if (status === -1) {
      status = 7;
    }
    const styles = {
      1: "bg-green-100 text-green-800 border-green-200",
      2: "bg-blue-100 text-blue-800 border-blue-200",
      4: "bg-blue-100 text-blue-800 border-blue-200",
      7: "bg-red-100 text-red-800 border-red-200"
    };

    const statusText = {
      1: "To Review",
      2: "Approved",
      3: "Completed",     
    };

    const text = statusText[status] || status;
    return ( 
      <span>{text}</span>        
    );
  };






// const handleEditClick = (record) => {  
//   setSelectedRecord(record);
//   setEditFormData({
//     minutes: record.minutes,
//     participation: record.participation,
//     focus: record.focus,
//     excused: record.excused,
//     status: record.status
//   });
//   setIsModalOpen(true);
// };





useEffect(() => {
  setCurrentPage(1);
}, [startDate, endDate, statusFilter, selectedGroup]);



useEffect(() => {
    if (!selectedTeam) return;

    const teamColors = teams.find(tm => tm.id === Number(selectedTeam))?.colors || '';
    
    if (teamColors) {
      try {
        const colorsArray = JSON.parse(teamColors);
        
        // 2. Actualizamos el estado con los nuevos colores
        setPrimaryColor('#' + colorsArray[0]);
        setAccentColor('#' + colorsArray[1]);
      } catch (error) {
        console.error("Error colors:", error);
      }
    }
  }, [selectedTeam]);


  //LOAD USER DATA
  useEffect(() => {
    //const username = window.wpUserData?.username;
    //const isLoggedIn = window.wpUserData?.isLoggedIn;
    const nonce = window.wpUserData?.nonce;

    //+TEST
    const username = 'webmasters';
    const isLoggedIn = true;
    
    const fetchUserData = async () => {
        if (!isLoggedIn) {
            console.log('No user logged');
            return;
        }
        
        const response = await fetch(
            `${WP_REST_BASE}/user-data?username=${username}`,
            {
                // headers: {
                //     'X-WP-Nonce': nonce
                // },
                // credentials: 'same-origin'
            }
        );
        
        const data = await response.json();        
        setUserData(data);
    };
    fetchUserData();
  }, []);


const canEditRecords = () => {
  return userData?.roles?.includes('administrator') || 
         userData?.roles?.includes('tosa');
};


  //LOAD TEAMS
  useEffect(() => {  
    if (!userData || !userData.model || (userData.model === 'participants')) {
        return;
    }

    const fetchTeams = async () => {
      try {

          const paramId = userData.id;
          const paramModel = userData.model;
          const nonce = window.wpUserData?.nonce;

          const url = `${WP_REST_BASE}/teams-user-data?id=${paramId}&model=${paramModel}`;
          const response = await fetch(url,
            {
              // headers: {
              //   'X-WP-Nonce': nonce
              // },
              // credentials: 'same-origin'
            }
          );      

          if (!response.ok) throw new Error("Error: " + response.status);
          const data = await response.json();
          setTeams(data);
          if (data.length > 0) setSelectedTeam(data[0].id);
          setIsVisible(true);
        } catch (err) {
          setError("Error connection: " + err.message);
          setLoading(false);
        }
    };
    fetchTeams();
    
  }, [userData]);
      

  //LOAD PROGRAMS
  useEffect(() => {  
    if (!userData || !userData.model || (userData.model === 'participants')) {
        return;
    }

    const fetchPrograms = async () => {
      try {

          const paramId = userData.id;
          const paramModel = userData.model;
          const nonce = window.wpUserData?.nonce;

          const url = `${WP_REST_BASE}/programs-user-data?id=${paramId}&model=${paramModel}`;
          const response = await fetch(url,
            // {
            //   headers: {
            //     'X-WP-Nonce': nonce
            //   },
            //   credentials: 'same-origin'
            // }
          );      

          if (!response.ok) throw new Error("Error: " + response.status);
          const data = await response.json();
          setPrograms(data);
          if (data.length > 0) setSelectedProgram(data[0].id);
          setIsVisible(true);
        } catch (err) {
          setError("Error connection: " + err.message);
          setLoading(false);
        }
    };
    fetchPrograms();
    
  }, [userData]);
    

//LOAD LOCATIONS
  useEffect(() => {

    if (!userData || !userData.model || (userData.model === 'participants')) {
        return;
    }

    setSelectedLocation('');

    const fetchLocations = async () => {
    try {

          const roles = userData.roles;
          const userId = userData.id;
          const paramModel = userData.model;
          const nonce = window.wpUserData?.nonce;
      
      const url = `${WP_REST_BASE}/locations-user-data?id=${userId}&model=${paramModel}`;            
      const response = await fetch(url,
        // {
        //     headers: {
        //         'X-WP-Nonce': nonce
        //     },
        //     credentials: 'same-origin'
        // }
      );      
      
      if (!response.ok) throw new Error("Error: " + response.status);
      const data = await response.json();
      
      const filteredLocations =  data.filter(item => item.teamid === parseInt(selectedTeam));

      setLocations(filteredLocations);

      setIsVisible(true);
    } catch (err) {            
      setLoading(false);
    }
  };

  fetchLocations();
}, [userData, selectedTeam, selectedProgram]);


  //LOCATION-ATTENDANCE
 useEffect(() => {
    if (!selectedLocation) return;
    const fetchLocationAttendanceData = async () => {
      setLoading(true);
      try {
        const wpNonce = window.wpUserData?.nonce;
        const response = await fetch(`${WP_REST_BASE}/attendance-location-program-data?id=${parseInt(selectedLocation)}&program=${parseInt(selectedProgram)}`);
        if (!response.ok) throw new Error("Error loading locations-attendance");
        const data = await response.json();        
        setLocationAttendanceData(data);        
        setLoading(false);
      } catch (err) {
        setLocationAttendanceData([]);
        setLoading(false);
      }
    };
    fetchLocationAttendanceData();
  }, [selectedLocation]);

  
  //GOALS
 useEffect(() => {    
    if (!selectedLocation) return;
    const fetchLocationGoalData = async () => {
      setLoading(true);
      try {
        
        const wpNonce = window.wpApiSettings?.nonce || "";
        const response = await fetch(`${WP_REST_BASE}/location-goals?location_id=${Number(selectedLocation)}`);
        if (!response.ok) throw new Error("Error loading goals");
        const data = await response.json();
        setlocationGoalData(data);
        console.log(data);
        setLoading(false);        
      } catch (err) {        
        setlocationGoalData([]);
        setLoading(false);
      }
    };
    fetchLocationGoalData();
  }, [selectedLocation]);


const groupLocationsByTeam = (locations) => {
  const groups = {};
  
  locations.forEach(loc => {
    const [teamname, ...rest] = loc.name.split(' - ');
    const locationName = rest.join(' - ');
    
    if (!groups[teamname]) {
      groups[teamname] = [];
    }
    groups[teamname].push({
      id: loc.id,
      name: loc.name
    });
  });
  
  return groups;
};

const groupedLocations = groupLocationsByTeam(locations);

const formatDateToMD = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return `${date.getMonth() + 1}/${date.getDate()}`;
};

const formatDateToMonthDay = (dateString) => {
  if (!dateString) return '';
  
  // Parsear la fecha string directamente
  const parts = dateString.split('-');
  if (parts.length !== 3) return dateString;
  
  const year = parseInt(parts[0]);
  const month = parseInt(parts[1]) - 1;
  const day = parseInt(parts[2]);
  
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthName = monthNames[month];
  
  return `${monthName}-${day}`;
};

const currentYear = new Date().getFullYear();
const minDate = `${currentYear}-01-01`;
const maxDate = `${currentYear}-12-31`;

const handleStartDateChange = (value) => {
  setStartDate(value);
  if (endDate && value > endDate) {
    setEndDate(value);
  }
};

const handleEndDateChange = (value) => {
  setEndDate(value);
};


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredGoals.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredGoals.length / itemsPerPage);

  // Cambiar de página
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };



const fetchLocationGoalData = async () => {
  if (!selectedLocation) return;
  
  setLoading(true);
  try {
    const wpNonce = window.wpUserData?.nonce;
    const response = await fetch(`${WP_REST_BASE}/location-goals?id=${Number(selectedLocation)}`);
    if (!response.ok) throw new Error("Error loading data");
    const data = await response.json();
    setlocationGoalData(data);
  } catch (err) {
    setlocationGoalData([]);
  } finally {
    setLoading(false);
  }
};

const [selectedRecord, setSelectedRecord] = useState(null);
const [newStatus, setNewStatus] = useState(null);

const handleVideoButtonsClick = (record, newStatus) => {  
  setSelectedRecord(record);  
  setNewStatus(newStatus);  
};


useEffect(() => {
  if (selectedRecord !== null && newStatus !== null) {    
    handleUpdateVideoStatus();
  }
}, [selectedRecord, newStatus]);

const handleUpdateVideoStatus = async () => {
     
  setLoading(true);
  
  try {
    const payload = {
      id: selectedRecord.id,
      status: newStatus
    };

    const url = `${WP_REST_BASE}/goal-update-status?id=${selectedRecord.id}`;
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
    
    if (!response.ok) {
      throw new Error('Failed to update record');
    }
    
    const updatedRecord = await response.json();

    //await fetchLocationVideoData();

    setlocationGoalData(prevData =>
        prevData.map(record =>
          record.id === selectedRecord.id ? updatedRecord.data : record
        )
      );    
    
    alert('Record updated successfully!');
    
  } catch (error) {
    console.error('Error updating record:', error);
    alert('Error updating record. Please try again.');
  } finally {
    setLoading(false);
    setSelectedRecord(null);
    setNewStatus(null);
  }
};





const EditModal = ({ isOpen, onClose, record, formData, onInputChange, onSave }) => {
  if (!isOpen) return null;

  // Opciones para los selects
  const minutesOptions = [0, 20, 25, 30, 45, 60, 90];
  const participationOptions = [0, 25, 50, 75, 100];
  const focusOptions = [0, 25, 50, 75, 100];

  // Función para renderizar select con validación
  const renderSelect = (name, label, options, unit = '') => {
    // Asegurar que el valor actual esté en las opciones
    const currentValue = formData[name];
    const isValidValue = options.includes(Number(currentValue));
    const displayValue = isValidValue ? currentValue : options[0];

    return (
      <div>
        <label className="block text-xs font-bold text-gray-600 uppercase mb-1">
          {label}
        </label>
        <select
          name={name}
          value={displayValue}
          onChange={onInputChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#06415b] focus:ring-1 focus:ring-[#06415b] text-sm bg-white"
        >
          {options.map(option => (
            <option key={option} value={option}>
              {option}{unit}
            </option>
          ))}
        </select>
      </div>
    );
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
        {/* Modal Header */}
        <div className="sticky top-0 bg-white flex justify-between items-center p-6 border-b border-gray-200">
          <h3 className="text-lg font-bold text-gray-800">Meta Smart</h3>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={20} />
          </button>
        </div>
        
        {/* Modal Body */}
        <div className="p-6 space-y-4">
          {/* Información del participante (solo lectura) */}
          <div className="bg-gray-50 p-4 rounded-lg mb-2">
            <p className="text-[10px] font-bold text-gray-400 uppercase">Título</p>
            <p className="text-sm font-semibold text-gray-800">{record?.title}</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg mb-2">
                      
            <div className="grid grid-cols-2 gap-2">
              <div>
                <p className="text-[10px] font-bold text-gray-400 uppercase">Participante</p>
                <p className="text-sm font-semibold text-gray-800">{record?.fullname}</p>
              </div>
              <div>
                <p className="text-[10px] font-bold text-gray-400 uppercase">Registrada</p>
                <p className="text-sm font-semibold text-gray-800">
                  {record && formatDateToMonthDay(record.created_at)}
                </p>
              </div>
            </div>
          </div>

          
          <div style={styles.reviewContainer}>                              
              <div style={styles.reviewItem}>
                <div style={styles.reviewItemHeader}>
                  <strong>Específica:</strong>
                  {/* <button type="button" onClick={() => handleJumpToStep(0)} style={styles.editBtn}>Editar</button> */}
                </div>                  
                <p className="text-sm font-semibold text-gray-800">{record?.gspecific}</p>
              </div>
              <div style={styles.reviewItem}>
                <div style={styles.reviewItemHeader}>
                  <strong>Medible:</strong>
                  {/* <button type="button" onClick={() => handleJumpToStep(0)} style={styles.editBtn}>Editar</button> */}
                </div>                  
                <p className="text-sm font-semibold text-gray-800">{record?.measurable}</p>
              </div>
              <div style={styles.reviewItem}>
                <div style={styles.reviewItemHeader}>
                  <strong>Alcanzable:</strong>
                  {/* <button type="button" onClick={() => handleJumpToStep(0)} style={styles.editBtn}>Editar</button> */}
                </div>
                <p className="text-sm font-semibold text-gray-800">{record?.achievable}</p>
              </div>
              <div style={styles.reviewItem}>
                <div style={styles.reviewItemHeader}>
                  <strong>Releveante:</strong>
                  {/* <button type="button" onClick={() => handleJumpToStep(0)} style={styles.editBtn}>Editar</button> */}
                </div>
                <p className="text-sm font-semibold text-gray-800">{record?.relevant}</p>
              </div>
              <div style={styles.reviewItem}>
                <div style={styles.reviewItemHeader}>
                  <strong>Temporal:</strong>
                  {/* <button type="button" onClick={() => handleJumpToStep(0)} style={styles.editBtn}>Editar</button> */}
                </div>                  

                <p className="text-sm font-semibold text-gray-800">{formatDateToMonthDay(record?.target_date)}</p>
                
              </div>

          </div>
          
                              
          <div>
            <label className="block text-xs font-bold text-gray-600 uppercase mb-1">
              Status
            </label>
            <p className="text-md font-semibold text-gray-800">{getStatusNameBadge(record?.status)}</p>            
          </div>
        </div>
        
        {/* Modal Footer */}
        <div className="sticky bottom-0 bg-white flex justify-end gap-3 p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-semibold text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={onSave}
            className="px-4 py-2 text-sm font-semibold text-white bg-[#06415b] rounded-lg hover:bg-[#043547] transition-colors flex items-center gap-2"
          >
            <Save size={16} /> Aprobar
          </button>
        </div>
      </div>
    </div>
  );
};








// const styles = {
//   overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
//   modal: { backgroundColor: '#fff', padding: '24px', borderRadius: '8px', width: '90%', maxWidth: '500px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
//   header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee', paddingBottom: '10px' },
//   closeBtn: { background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' },
//   progress: { margin: '15px 0', fontSize: '14px', color: '#666', fontWeight: 'bold' },
//   form: { display: 'flex', flexDirection: 'column', gap: '15px' },
//   stepContainer: { display: 'flex', flexDirection: 'column', gap: '8px' },
//   stepTitle: { margin: 0, color: '#333' },
//   label: { fontSize: '14px', color: '#555' },
//   textarea: { width: '100%', height: '100px', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', resize: 'none', boxSizing: 'border-box' },
//   actions: { display: 'flex', justifyContent: 'space-between', marginTop: '10px' },
//   btn: { padding: '10px 20px', borderRadius: '4px', border: 'none', cursor: 'pointer', fontWeight: 'bold' },
//   btnActive: { backgroundColor: '#f0f0f0', color: '#333' },
//   btnDisabled: { backgroundColor: '#e0e0e0', color: '#aaa', cursor: 'not-allowed' },
//   btnNext: { backgroundColor: '#007bff', color: '#fff' },
//   btnSubmit: { backgroundColor: '#28a745', color: '#fff' }
// };







  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-8 font-sans text-gray-900 print:bg-white print:p-0">
      <style>
        {`
          @media print {
            .no-print { display: none !important; }
            .print-shadow-none { box-shadow: none !important; border: 1px solid #eee !important; }
            body { background: white; }
            @page { margin: 1cm; }
          }
          .animate-fade-in { animation: fadeIn 0.8s ease-out forwards; }
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>














{!isParticipant ? (
      <div className="max-w-4xl mx-auto mb-6 no-print">
        <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Team */}
            <div className="w-full">              
              <label className="text-[10px] font-black text-gray-400 uppercase mb-2 ml-1 flex items-center gap-1">
                <LandPlot size={14} /> Equipo
              </label>
              <select value={selectedTeam} onChange={(e) => setSelectedTeam(e.target.value)}
                  className="w-full bg-gray-50 border border-gray-100 p-3 rounded-xl font-bold text-sm focus:ring-2 focus:ring-[#06415b] outline-none">                
                  {teams.map(tm => (
                    <option key={tm.id} value={tm.id}>
                      {tm.code} - {tm.name}
                    </option>
                  ))}
              </select>
            </div>

            {/* Program */}
            <div className="w-full">              
              <label className="text-[10px] font-black text-gray-400 uppercase mb-2 ml-1 flex items-center gap-1">
                <SquareChartGantt size={14} /> Programa
              </label>
              <select value={selectedProgram} onChange={(e) => setSelectedProgram(e.target.value)}
                  className="w-full bg-gray-50 border border-gray-100 p-3 rounded-xl font-bold text-sm focus:ring-2 focus:ring-[#06415b] outline-none">                
                  {programs.map(prog => (
                    <option key={prog.id} value={prog.id}>
                      {prog.name}
                    </option>
                  ))}
              </select>
            </div>

            {/* Location */}
            <div className="w-full">
              <label className="text-[10px] font-black text-gray-400 uppercase mb-2 ml-1 flex items-center gap-1">
                <MapPin size={14} /> Ubicación
              </label>
              <select value={selectedLocation} onChange={(e) => setSelectedLocation(e.target.value)}            
                className="w-full bg-gray-50 border border-gray-100 p-3 rounded-xl font-bold text-sm focus:ring-2 focus:ring-[#06415b] outline-none">
                  <option value="">Seleccionar...</option>
                  {Object.entries(groupedLocations).map(([teamname, teamLocations]) => (
                    <optgroup key={teamname} label={teamname}>
                      {teamLocations.map(loc => (
                        <option key={loc.id} value={loc.id}>
                          {loc.name}
                        </option>
                      ))}
                    </optgroup>
                  ))}
              </select>
            </div>

    <div className="w-full">
      <label className="text-[10px] font-black text-gray-400 uppercase mb-2 ml-1 flex items-center gap-1">
              <User size={14} /> Grupo
              </label>
      <select 
        value={selectedGroup}
        onChange={(e) => setSelectedGroup(e.target.value)}
        className="w-full bg-gray-50 border border-gray-100 p-3 rounded-xl font-bold text-sm focus:ring-2 focus:ring-[#06415b] outline-none">                      
        <option value="">Todos</option>
        {uniqueGroups.map(group => (
          <option key={group.id} value={group.id}>
            {group.name}
          </option>
        ))}
      </select>
    </div>

    {/* <div className="flex flex-col gap-1">
      <label className="text-[10px] font-black text-gray-400 uppercase mb-2 ml-1 flex items-center gap-1">
          <Calendar size={14} /> From Date
      </label>      
      <input 
        type="date" 
        value={startDate}
        onChange={(e) => handleStartDateChange(e.target.value)}
        min={minDate}
        max={maxDate}
        className="w-full bg-gray-50 border border-gray-100 p-3 rounded-xl font-bold text-sm focus:ring-2 focus:ring-[#06415b] outline-none"                              
      />
    </div>
        
    <div className="flex flex-col gap-1">
      <label className="text-[10px] font-black text-gray-400 uppercase mb-2 ml-1 flex items-center gap-1">
          <Calendar size={14} /> To Date
      </label>     
      <input 
        type="date" 
        value={endDate}
        onChange={(e) => handleEndDateChange(e.target.value)}
        min={minDate}
        max={maxDate}                    
        className="w-full bg-gray-50 border border-gray-100 p-3 rounded-xl font-bold text-sm focus:ring-2 focus:ring-[#06415b] outline-none"
      />
    </div> */}
    
        <div className="flex flex-col gap-1">      
      <label className="text-[10px] font-black text-gray-400 uppercase mb-2 ml-1 flex items-center gap-1">
          <User size={14} /> Participante
      </label>
      <select 
        value={selectedParticipant}
        onChange={(e) => setSelectedParticipant(e.target.value)}
        className="w-full bg-gray-50 border border-gray-100 p-3 rounded-xl font-bold text-sm focus:ring-2 focus:ring-[#06415b] outline-none"
      >
        <option value="">Todos</option>
         {uniqueParticipants.map(participant => (
          <option key={participant.id} value={participant.id}>
            {participant.name}
          </option>
        ))}
      </select>
    </div>
    
    <div className="flex flex-col gap-1">
      <label className="text-[10px] font-black text-gray-400 uppercase mb-2 ml-1 flex items-center gap-1">
          <Target size={14} /> Status
      </label>      
      <select 
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
        className="w-full bg-gray-50 border border-gray-100 p-3 rounded-xl font-bold text-sm focus:ring-2 focus:ring-[#06415b] outline-none"
      >
        <option value="">Todos</option>
        <option value="1">Aprobado</option>
        <option value="2">En revisión</option>
        <option value="3">Completado</option>
      </select>
    </div>


          </div>
        </div>
      </div>
) :
(
  <div></div>
)
}

{selectedTeam &&
<div className="max-w-4xl mx-auto mb-2 bg-white shadow-2xl rounded-xl overflow-hidden border border-gray-200 print-shadow-none animate-fade-in">
  <div className="p-4 sm:p-6 md:p-10 border-b border-gray-50 bg-gray-50/10">
    {/* Header - T�tulo */}
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
      <div className="flex items-center gap-2 sm:gap-3">
        <BookOpen style={{ color: primaryColor }} size={18} className="sm:w-5 sm:h-5" />
        <h2 className="font-black uppercase tracking-widest text-[10px] sm:text-xs md:text-sm">Metas SMART</h2>
      </div>
    </div>



          <div className="p-2 mb-4">
                  <button  style={{ backgroundColor: primaryColor }} 
                    onClick={() => setIsModalOpen(true)}
                    className="w-full md:w-auto h-[46px] px-4 rounded-xl text-white font-black text-xs tracking-widest shadow-lg hover:opacity-90 transition-all flex items-center justify-center gap-2 md:ml-auto">
                    <CirclePlus size={20} /> Nueva meta
                  </button>
                </div>    

    
    {filteredGoals && filteredGoals.length > 0 ? (

<div className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm">
                <div className="overflow-x-auto">
                  <table className="w-full text-left border-collapse">
                    <thead>
                      <tr className="bg-gray-50 border-b border-gray-100">
                        <th className="p-4 ml-2 text-[9px] font-black uppercase text-gray-400 tracking-widest cursor-pointer hover:bg-gray-100 transition-colors">Participante</th>
                        <th className="p-4 text-[9px] font-black uppercase text-gray-400 tracking-widest cursor-pointer hover:bg-gray-100 transition-colors">Nombre de meta</th>
                        <th className="p-4 text-[9px] font-black uppercase text-gray-400 tracking-widest text-center">Creada</th>
                        <th className="p-4 text-[9px] font-black uppercase text-gray-400 tracking-widest text-center">Fecha compromiso</th>
                        <th className="p-4 text-[9px] font-black uppercase text-gray-400 tracking-widest text-center">Status</th>
                        <th className="p-4 text-[9px] font-black uppercase text-gray-400 tracking-widest text-center">Acciones</th>                        
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50">
                      {currentItems.map((record, index) => (
                        <tr key={index} className="hover:bg-gray-50/50 transition-colors">
                          <td className="p-4 ml-2 text-[12px] font-bold text-gray-700 items-center gap-2">
                            {record.fullname}
                          </td>
                          <td className="p-4 ml-2 text-[12px] font-bold text-gray-700 items-center gap-2">
                            {record.title}
                          </td>
                          <td className="p-4 text-sm text-gray-500 font-medium">
                            {formatDateToMonthDay(record.created_at)}
                          </td>
                          <td className="p-4 text-sm text-gray-500 font-small text-center">
                            {formatDateToMonthDay(record.target_date)}
                          </td>
                          <td className="p-4 text-center">
                            {getStatusBadge(record.status)}
                          </td>                          
                          <td className="p-4 text-center">
                            {/* <button
                              onClick={() => handleEditClick(record)}
                              className="p-1 text-gray-400 hover:text-[#06415b] transition-colors"
                              title="Edit record"
                            >
                              <Edit size={18} />
                            </button> */}
                            <button
                              onClick={() => handleEditClick(record)}
                              className="p-1 text-gray-400 hover:text-[#06415b] transition-colors"
                              title="Edit record"
                            >
                              <EyeIcon size={18} />
                            </button> 
                          </td>
                        </tr>
                      ))}
                    </tbody>                    

                  </table>

                </div>




              </div>


      
    ) : (
      <div className="text-center py-8 sm:py-10 bg-white rounded-3xl border-2 border-dashed border-gray-100">
        <BookOpen className="text-gray-200 mx-auto mb-2" size={24} />
        <p className="text-[10px] sm:text-xs font-bold text-gray-400 uppercase tracking-widest">No se encontraron Metas SMART</p>
      </div>
    )}


<div className="flex justify-between items-center mt-4 px-4 py-3 bg-gray-50/10 border-t border-gray-100">
                      <div className="text-sm text-gray-500">
                        Mostrando {indexOfFirstItem + 1} a {Math.min(indexOfLastItem, filteredGoals.length)} de {filteredGoals.length} registros
                      </div>
                      
                      <div className="flex gap-2">
                        <button
                          onClick={prevPage}
                          disabled={currentPage === 1}
                          className={`px-3 py-1 rounded text-xs font-semibold ${
                            currentPage === 1
                              ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                          }`}
                        >
                          Anterior
                        </button>
                        
                        <button
                          onClick={nextPage}
                          disabled={currentPage === totalPages}
                          className={`px-3 py-1 rounded text-xs font-semibold ${
                            currentPage === totalPages
                              ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                          }`}
                        >
                          Siguiente
                        </button>
                      </div>
                    </div>

  </div>
</div>

}
      
      <div className="mt-8 text-center text-gray-400 text-[10px] font-bold uppercase tracking-[0.3em] no-print">
        � 2026 HSA - Smart Goals
      </div>


      <SmartGoalModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onSubmit={handleSaveSmartGoal}
      />

      <EditModal
        isOpen={isModalEditOpen}
        onClose={() => setIsModalEditOpen(false)}
        record={selectedRecord}
        formData={editFormData}
        onInputChange={handleInputChange}
        onSave={handleSaveChanges}
      />

    </div>
  );
};

const styles = {
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
  modal: { backgroundColor: '#ffffff', padding: '28px', borderRadius: '12px', width: '90%', maxWidth: '550px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', fontFamily: 'system-ui, -apple-system, sans-serif' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '14px' },
  headerTitle: { margin: 0, fontSize: '20px', color: '#1e293b' },
  closeBtn: { background: 'none', border: 'none', fontSize: '28px', color: '#94a3b8', cursor: 'pointer', lineHeight: '1' },
  progressContainer: { margin: '20px 0 10px 0' },
  progressText: { fontSize: '13px', color: '#64748b', fontWeight: '600' },
  progressBarOuter: { width: '100%', height: '6px', backgroundColor: '#f1f5f9', borderRadius: '999px', marginTop: '6px', overflow: 'hidden' },
  progressBarInner: { height: '100%', backgroundColor: '#3b82f6', transition: 'width 0.3s ease-in-out' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  stepContainer: { display: 'flex', flexDirection: 'column', gap: '10px' },
  stepTitle: { margin: 0, color: '#0f172a', fontSize: '18px' },
  label: { fontSize: '14px', color: '#475569', lineHeight: '1.4' },
  textarea: { width: '100%', height: '110px', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '15px', color: '#334155', resize: 'none', boxSizing: 'border-box', outline: 'none', fontFamily: 'inherit' },
  dateInput: { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '16px', color: '#334155', boxSizing: 'border-box', outline: 'none', fontFamily: 'inherit' },
  
  // Contenedor de revisión
  reviewContainer: { display: 'flex', flexDirection: 'column', gap: '14px', backgroundColor: '#f8fafc', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0', maxHeight: '320px', overflowY: 'auto' },
  reviewItem: { borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' },
  reviewItemHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  
  // Botón pequeño de edición rápida
  editBtn: {
    background: 'none',
    border: 'none',
    color: '#3b82f6',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: '4px',
    backgroundColor: '#eff6ff',
    transition: 'all 0.1s ease'
  },

  reviewText: { margin: '6px 0 0 0', fontSize: '14px', color: '#334155', whiteSpace: 'pre-wrap', lineHeight: '1.5' },
  actions: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' },
  btn: { padding: '10px 22px', borderRadius: '6px', border: 'none', fontSize: '14px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease' },
  btnBackActive: { backgroundColor: '#f1f5f9', color: '#475569' },
  btnNextActive: { backgroundColor: '#c44c46', color: '#ffffff' },
  btnSubmitActive: { backgroundColor: '#06415b', color: '#ffffff' }, 
  btnDisabled: { backgroundColor: '#e2e8f0', color: '#94a3b8', cursor: 'not-allowed' }
};


const App = () => {
    return <SmartGoals />;
};

export default App;
